// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-width-item[data-v-98ac77d6] {\n  width: 900px;\n}\n", ""]);
// Exports
module.exports = exports;
